import { useState, useEffect, useContext, useMemo } from 'react';
import { FetchSingleData } from '../../../../hooks/FetchData';
import { ModalContainer, MainContentContainer1, IconContainer, UIcon, StyleButton, StyleLabel, StyleInput, SubmitContainer } from './CreateAdminUser'
import { FilterDropDown, option1, option2 } from '../../../../ui-components';
import { useSettingModal } from '../../../../hooks/Context';
import { apiRequest, config2,apiFormRequest } from '../../../../api';
import { useDispatch } from 'react-redux';
import { Waiting } from '.';
import { addApprovalConfig } from '../../../../redux/reducers/approvalReducer';
import { NotificationContext } from '../../../../providers/notification';
import FetchRoute  from '../../../../hooks/fetchRoute';
import apiCall from '../../../../utils/apiCall';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

interface RouteData {
    RouteName: string;
    RouteId: number;
    Status: boolean;
    StateDate: string;
    EndDate: string;
}

interface AdminRole {
    Id: string;
    Name: string;
    NormalizedName: string;
}

interface AdminRoleProps {
    data: AdminRole[];
}

const CreateAdminConfig = (props:any ={}) => {
    const [approvalName,setApprovalName] = useState<any>(null);
    const [routeName,setRouteName] = useState<any>(null);
    const [roleEmail,setRoleEmail] = useState<any>('');
    const [userRole,setUserRole] = useState<any>(null);
    const [tMember,setTMember] = useState<any>(null);

    const dispatch = useDispatch();
    const data = props?.data ? props?.data : null;
    const { setShowModal, setShowCancel, setModalContent } = useSettingModal();
    const { data: roleData, isLoading: loadingRole } = FetchSingleData('admin-role','api/Administration/roles/readall');
    const { showNotification } = useContext(NotificationContext);
  //const {data: route, isError, isLoading, error} = useRoute();

    const {memoData} = FetchRoute();

    const getAllRole = async (): Promise<AdminRoleProps> => {
        const url = '/Administration/roles/readall';
        return (await apiCall().get(url)); 
    };

    const { data: role, isLoading, isError, error } = useQuery(['get-all-role'], getAllRole, {
        retry: 0,
        enabled: true,
        keepPreviousData: true,
    });

    const adminRoleError = error as AxiosError;
    const adminRoleErrorMessage = adminRoleError?.message;
  
    const emails = props.emails;
    const aTypes = props.aTypes;
    let emailList = [];
    let aTypeList = [];

    if(emails?.length > 0){
        emailList = emails.map((eEmail: any, index: number) => ({val: index + 1, name: eEmail.RoleEmails}))
    };

    if(aTypes?.length > 0){
        aTypeList = aTypes.map((eTypes: any, index: number) => ({val: eTypes.ApprovalTypeId, name: eTypes.ApprovalTypName}));
    };

    const handleSubmit = (e:any) => {
        e.preventDefault();

        const ApprovalTypeId = approvalName?.val;
        const ApprovalTypName = approvalName?.name;
        const RouteId = routeName?.val;
        const RouteName = routeName?.name;
        const RoleEmails = roleEmail;
        const RoleName = userRole?.name;
        const RoleId = userRole?.val;
        const TargetedMembersId = '1';
        const TargetedMembers = tMember?.name;
        const apiConfig = config2;
        const tokenModel = JSON.parse(localStorage.getItem('admin-auth') || '{}');
        apiConfig.Authorization = `Bearer ${tokenModel.Token}`;
        const body = new FormData();
        // body.append('ApprovalConfigId',ApprovalConfigId);
        body.append('ApprovalTypeId', ApprovalTypeId?.toString());
        body.append('ApprovalTypName',ApprovalTypName);
        body.append('RouteId',RouteId?.toString());
        body.append('RouteName',RouteName);
        body.append('RoleEmails',RoleEmails);
        body.append('RoleName',RoleName);
        body.append('RoleId',RoleId);
        body.append('TargetedmembersId',TargetedMembersId);
        body.append('TargetedMembers',TargetedMembers);

        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

        if(approvalName === null) {
            showNotification({
                type: 'error',
                message: 'Approval type is required'
            })
            return;
        }

        if(routeName === null) {
            showNotification({
                type: 'error',
                message: 'Route name is required'
            })
            return;
        }

        if(tMember === null) {
            showNotification({
                type: 'error',
                message: 'Membership type is required'
            })
            return;
        }

        if(userRole === null) {
            showNotification({
                type: 'error',
                message: 'Role name is required'
            })
            return;
        }

        if(!emailRegex.test(RoleEmails)) {
            RoleEmails?.length === 0 ?
            showNotification({
                type: 'error',
                message: 'Email is required'
            }) 
            : showNotification({
                type: 'error',
                message: 'invalid email'
            })
            return;
        }
        
        try {
            setModalContent(<Waiting message="Please Wait ..." />)
            setShowCancel(false)
            setShowModal(true);
            apiFormRequest('api/ApprovalConfig/Create', body)
            .then(data =>  {
                setModalContent(<Waiting message="Approval Configuration created Successfully" />)
                dispatch(addApprovalConfig(data));
                setShowCancel(true)
                setShowModal(true);
            })
            .catch(e => {
                setModalContent(<Waiting message={e?.message || e?.Message} />)
                setShowCancel(false)
                setShowModal(true);
                setTimeout(()=>{
                    setModalContent(<CreateAdminConfig email={emails} aTypes={aTypes} />);
                    setShowCancel(true);
                    setShowModal(true);
                },3000)
            
            })

        }
        catch(err){
       
        }
    }

    const handleUpdate = (e:any)=>{
        e.preventDefault();

        let body:any = {};
        const Id = data.ApprovalConfigId ||  1;
        body.ApprovalConfigId = Id;
        body.ApprovalTypeId = approvalName.val || 1;
        body.ApprovalTypName = approvalName.name || '';
        body.RouteId = routeName.val || 1;
        body.RouteName = routeName.name || '';
        body.RoleId = userRole.val || 1;
        body.RoleName = userRole.name || '';
        body.RoleEmails = roleEmail || '';
        body.TargetedMembersId = data.TargetedMembersId || 1;
        body.TargetedMembers = data.MembershipTypes || '';

        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

        if(approvalName === null) {
            showNotification({
                type: 'error',
                message: 'Approval type is required'
            })
            return;
        }

        if(routeName === null) {
            showNotification({
                type: 'error',
                message: 'Route name is required'
            })
            return;
        }

        if(tMember === null) {
            showNotification({
                type: 'error',
                message: 'Membership type is required'
            })
            return;
        }

        if(userRole === null) {
            showNotification({
                type: 'error',
                message: 'Role name is required'
            })
            return;
        }

        if(!emailRegex.test(roleEmail)) {
            roleEmail?.length === 0 ?
            showNotification({
                type: 'error',
                message: 'Email is required'
            }) 
            : showNotification({
                type: 'error',
                message: 'invalid email'
            })
            return;
        }

        body = JSON.stringify(body); 
        apiRequest(`api/ApprovalConfig/UpdateApprovalConfig/${Id}`,'PUT',body)
        .then(result =>{
            setShowModal(false);
            if(result.StatusCode >= 200 && result.StatusCode <= 299){
                showNotification({
                    message:result.Message || 'Approval Config Updated Successfully',
                    type:'success'
                })
                //call update reducer here.
            }else{
                showNotification({
                    message:result.Message || 'Approval Config Not Updated',
                    type:'error'
                })
            }
        })
        .catch(error =>{
            setShowModal(false);
            showNotification({
                message:'Oops Sorry. Request cannot be Sent, Try again later.',
                type:'error'
            })
        })
    }

    useEffect(()=>{
        if(data) {
            setRoleEmail(data?.RoleEmails);
            setApprovalName({name: data?.ApprovalTypName, val:data?.ApprovalTypeId});
            setRouteName({name:data?.RouteName,val:data?.RouteId});
            setUserRole({name:data?.RoleName,val:data?.RoleId});
        }
    },[data])
    
    let roles = roleData &&  roleData?.length > 0 ? roleData?.map((eRole: any) => ({val: eRole.Id, name: eRole.Name})) : [];

    const allRoutes = memoData?.isLoading ? [] : memoData?.data && memoData?.data.Data?.map((item: RouteData) => {return {name: item?.RouteName, val: item?.RouteId}})

    const allRoles = isLoading ? [] : role?.data?.map((item: AdminRole) => {return {name: item?.Name, val: item?.Id}})

  return (
    <ModalContainer>
        <div>
            <div>
                <div>
                    <IconContainer><UIcon /></IconContainer>
                    <span>{data ? 'Update Approval Config' : 'Create Approval Config'}</span>
                </div>
            </div>
            <MainContentContainer1 onSubmit={data ? handleUpdate : handleSubmit}>
                
                <StyleLabel >
                    <span>Approval Type</span>
                    <FilterDropDown 
                        onChange={setApprovalName} 
                        style={{width:'100%', border:'1px solid #E1E1E1', borderRadius:'5px'}} 
                        options={aTypeList} 
                        text={data ? data.ApprovalTypName ? data.ApprovalTypName : "Approval Type" : 'Approval Type'} 
                        replace="1" 
                        bg="#fff" 
                        color="#555"
                    />
                </StyleLabel>
                <StyleLabel>
                    <span>Route</span>
                    <FilterDropDown 
                        onChange={setRouteName} 
                        style={{width:'100%', border:'1px solid #E1E1E1', borderRadius:'5px'}} 
                        options={allRoutes} 
                        text={data?data.RouteName?data.RouteName:"Route":'Route'} 
                        replace="1" 
                        bg="#fff" 
                        color="#555" 
                    />
                </StyleLabel>

                <StyleLabel >
                    <span>Membership Type</span>
                    <FilterDropDown 
                        style={{width:'100%',border:'1px solid #E1E1E1',borderRadius:'5px'}} 
                        onChange={setTMember} 
                        options={option2()} 
                        text="Membership Type" 
                        replace="1" 
                        bg="#fff" 
                        color="#555" 
                    />
                </StyleLabel>
              
                <StyleLabel >
                    <span>Role</span>
                    <FilterDropDown 
                    style={{width:'100%',border:'1px solid #E1E1E1',borderRadius:'5px'}} 
                    options={allRoles} text={data?data.RoleName?data.RoleName:"Role":'Role'} 
                    replace="1" 
                    bg="#fff" 
                    color="#555" 
                    onChange={setUserRole} 
                />
                </StyleLabel>
            
                <StyleLabel>
                    <span>Role's Email</span>
                    <StyleInput type='text'  onChange={(e:any) => setRoleEmail(e?.target?.value)} value={roleEmail}/>
                    {/* <FilterDropDown style={{width:'100%',border:'1px solid #E1E1E1',borderRadius:'5px'}} onChange={setRoleEmail} options={emailList} text="Role's Email" replace="1" bg="#fff" color="#555" /> */}
                </StyleLabel>
                <SubmitContainer>
                    <span onClick={()=>setShowModal(false)}>Cancel</span>
                    <StyleButton type='submit'>
                        {data ? "Update" : 'Submit'}
                    </StyleButton>
                </SubmitContainer>
            </MainContentContainer1>
        </div>
    </ModalContainer>
  )
}

export default CreateAdminConfig